module.exports = __webpack_public_path__ + "static/img/iddis.9c35313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/iddis.png
// module id = tLDw
// module chunks = 0